import { createStyles } from '@material-ui/core';

const styles = createStyles({
    parentcontainer: {
        height: 'calc(100% - 158px)',
        display: 'flex',
    },
    container: {
        'display': 'grid',
        'gridTemplateColumns': '1fr 520px 320px',
        'gridTemplateAreas': '"specs image summary"',
        'gap': '20px',
        'padding': '16px',
        'maxWidth': '100%',
        'boxSizing': 'border-box',
        'overflowX': 'auto',
        'paddingLeft': 20,
        '@media (max-width: 1539px)': {
            gridTemplateColumns: '1fr 320px',
            gridTemplateAreas: `
      "specs summary"
      "image summary"
    `,
        },
    },
    specs: {
        gridArea: 'specs',
        backgroundColor: '#fff',
        padding: '16px',
        height: 480,
        borderRadius: 0,
    },
    specsHeading: {
        backgroundColor: '#dddddd',
        padding: '0.5rem',
        textTransform: 'uppercase',
        fontSize: '1rem',
    },
    image: {
        gridArea: 'image',
        height: 512,
        padding: '16px',
        backgroundColor: '#fff',
        boxSizing: 'border-box',
    },

    summary: {
        gridArea: 'summary',
    },
    imageElement: {
        maxWidth: '100%',
        height: 'auto',
    },
    grid: {
        height: '96%',
        width: '100%'
    },
});

export const SummaryPaperStyles = {
    width: 300,
    float: 'unset',
    margin: 'unset',
    boxShadow: 'unset',
    borderRadius: 'unset',
    padding: 8,
};

export default styles;
